import { ContentBlock } from "../ContentBlock/ContentBlock";
import {
    GeoAltFill,
    Award,
    TrophyFill,
    GiftFill,
    CashStack,
    PeopleFill,
    PaletteFill,
    ShieldFill,
    ChatTextFill,
} from 'react-bootstrap-icons';
import './GameFeatures.css';

const features = [
    {
        icon: <GeoAltFill />,
        title: 'US Hosted',
        desc: 'Stable, low-latency server hosted in the United States.',
    },
    {
        icon: <Award />,
        title: 'Version 6609',
        desc: 'WindWalker era — all content, classes, and systems fully unlocked.',
    },
    {
        icon: <TrophyFill />,
        title: 'Max Level 140',
        desc: 'High leveling rate so you reach endgame content fast.',
    },
    {
        icon: <GiftFill />,
        title: 'Free Starter Gear',
        desc: 'New accounts receive gear and a guided newbie quest.',
    },
    {
        icon: <CashStack />,
        title: '150 CP Drops',
        desc: 'Balanced, fair spawn rates guarantee a rewarding grind.',
    },
    {
        icon: <PeopleFill />,
        title: 'Subclasses & Chi',
        desc: 'Subclasses, Chi system, and refinery — all available. No Jiang-Hu.',
    },
    {
        icon: <PaletteFill />,
        title: 'Custom Cosmetics',
        desc: 'Unique garments and personal accessories to stand out from the crowd.',
    },
    {
        icon: <ShieldFill />,
        title: 'Epic Classes',
        desc: 'Play as Epic Ninja, Trojan, Monk, or Taoist with unique combat styles.',
    },
    {
        icon: <ChatTextFill />,
        title: 'Ticket Support',
        desc: 'Dedicated staff support system to resolve in-game issues quickly.',
    },
];

export function GameFeatures() {
    return (
        <ContentBlock header="Game Features">
            <div className="features-grid">
                {features.map((f, i) => (
                    <div key={i} className="feature-card">
                        <div className="feature-icon">{f.icon}</div>
                        <div className="feature-text">
                            <span className="feature-title">{f.title}</span>
                            <p className="feature-desc">{f.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </ContentBlock>
    );
}
